import { EPNodeFieldsResolvers } from '../5-node/fields';
export const epExamLevelFieldsResolvers = {
    EPExamLevel: EPNodeFieldsResolvers,
};
